import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { createContext } from "react";
import useAxios from "axios-hooks";
import Loader from "../components/Loader";
export var Context = createContext();

var addMinutes = function addMinutes(a, b) {
  return new Date(a.getTime() + 6e4 * b);
},
    cache = {
  get: function get() {
    var a = localStorage.getItem("cache");
    return a ? JSON.parse(localStorage.getItem("cache")) : {};
  },
  set: function set(a) {
    // Cache system that refreshes every 10 mins.
    var b = addMinutes(new Date(), 10);
    localStorage.setItem("cache", JSON.stringify({
      data: a,
      expiresAt: b
    }));
  },
  hasExpired: function hasExpired() {
    var a = this.get(),
        b = a.data,
        c = a.expiresAt;
    if (!b || !c) return !0; // Check if expire date has passed

    var d = new Date(c),
        e = new Date();
    return !!(e > d);
  }
},
    Cache = function Cache(a) {
  var b = cache.get(),
      c = b.data;
  return /*#__PURE__*/React.createElement(Context.Provider, Object.assign({}, a, {
    value: [{
      data: c,
      loading: !1,
      error: !1
    }]
  }));
},
    Axios = function Axios(a) {
  var b = a.url,
      c = _objectWithoutProperties(a, ["url"]),
      d = useAxios(b),
      e = _slicedToArray(d, 1),
      f = e[0],
      g = f.data,
      h = f.loading,
      i = f.error;

  return h ? /*#__PURE__*/React.createElement(Loader, null) : (g && cache.set(g), /*#__PURE__*/React.createElement(Context.Provider, Object.assign({}, c, {
    value: [{
      data: g,
      loading: h,
      error: i
    }]
  }))); // if this component is rendered it means that the cache has expired
  // So save to cache new data that was queried.
};

export var ApiProvider = function ApiProvider(a) {
  var b = a.url,
      c = _objectWithoutProperties(a, ["url"]); // Use cache component only if it hasn't expired


  return cache.hasExpired() ? /*#__PURE__*/React.createElement(Axios, Object.assign({}, c, {
    url: b
  })) : /*#__PURE__*/React.createElement(Cache, c); // Axios is the default way of getting data
};
export default ApiProvider;